import React from 'react';
import PropTypes from 'prop-types';

const SliderBullets = ({ style, children, bottomLimit, topLimit }) => {
	if (children !== bottomLimit && children !== topLimit) {
		return (
			<div
				className="bar-bullets"
				style={{
					...style
				}}
			/>
		);
	} else {
		return null;
	}
};

SliderBullets.propTypes = {
	style: PropTypes.shape({}).isRequired,
	children: PropTypes.number.isRequired,
	bottomLimit: PropTypes.number.isRequired,
	topLimit: PropTypes.number.isRequired
};

export default React.memo(SliderBullets);
